<template>
    <div
        class="ticket-stack__folded-tickets"
        v-if="isExpanded"
    >
        <div class="folded-tickets-icon">
            <i
                class="icon icon-chevron_down"
                @click="toggleOpen"
            />
            <div class="ticket-items">
                <TicketHeader
                    v-for="ticket in tickets"
                    :key="ticket.id"
                    v-bind="ticket"
                    :isExpanded="false"
                    v-on="$listeners"
                    @click="onHeaderClick(ticket.id)"
                />
            </div>
        </div>
    </div>
    <div
        class="ticket-stack__folded-tickets"
        v-else
    >
        <div class="folded-tickets-icon">
            <div
                class="folded-tickets-text"
                @click="toggleOpen"
            >
                {{ `+${this.tickets.length}` }}
            </div>
        </div>
    </div>
</template>

<script>
    import TicketHeader from './TicketHeader';

    export default {
        props: {
            tickets: {
                type: Array,
                required: false,
                default() {
                    return [];
                }
            },
            isExpanded: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            toggleOpen() {
                this.$emit('toggleFolded');
            },
            onHeaderClick(id) {
                this.$emit('unfold', id);
            },
            onClickOutside() {
                this.$emit('toggleFolded', false);
            },
        },
        created() {
            this.clickListener = window.addEventListener('click', (event) => {
                if (!this.$el.contains(event.target)) {
                    this.onClickOutside();
                }
            }, true);
        },
        beforeDestroy() {
            window.removeEventListener('click', this.clickListener, true);
        },
        components: {
            TicketHeader,
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/ticketsWidget/components/FoldedTickets.vue